import { render, staticRenderFns } from "./dialogDocu.html?vue&type=template&id=50738128&class=ml-0%20mr-0&"
import script from "./DialogDocu.vue?vue&type=script&lang=js&"
export * from "./DialogDocu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports